<template>
    <div id="app">
     <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb :items="[{ path: 'basicData' }, { path: 'positionTion' }]" />
    <!-- li -->
    <div class="lisai">
      <!-- // 小区 -->
      <div class="modular">
        <div class="query">
          <span>{{$t('positionInfo.小区')}}</span>
          <el-input :placeholder="$t('positionInfo.请搜索')" size="mini" v-model.trim="comities.search_content" clearable @clear="QingChu"></el-input>
          <el-button size="mini" @click="table">{{$t('positionInfo.查询')}}</el-button>
          <el-button size="mini" @click="residentialbtn">{{$t('positionInfo.添加')}}</el-button>
        </div>
        <div class="tableData">
        <el-card>
          <el-table
          :data="tableData"
          size=mini
          highlight-current-row
          @current-change="handleCurrentChange"
          :header-cell-style = "{background:'#987AFF'}"
          height='400'>
            <!-- <el-table-column type="index" width="40" v-if="!isMobile" /> -->
            <el-table-column property="name" :label="$t('positionInfo.小区名称')":show-overflow-tooltip="true" />
            <el-table-column property="valve" :label="$t('positionInfo.操作')" >
              <template slot-scope="scope">
                <el-button size="mini" @click="Cellbtn(scope.row)">{{$t('positionInfo.修改')}}</el-button>
                <el-button size="mini" @click="Celldeletion(scope.row)">{{$t('positionInfo.删除')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        </div>
      </div>
      <!-- 楼栋 -->
      <div class="modular">
        <div class="query">
          <span>{{$t('positionInfo.楼栋')}}</span>
          <el-input :placeholder="$t('positionInfo.请搜索')" size="mini" v-model.trim="buings.search_content" clearable @clear="QingChu"></el-input>
          <el-button size="mini" @click="Building">{{$t('positionInfo.查询')}}</el-button>
          <el-button size="mini" @click="Buildingbtn">{{$t('positionInfo.添加')}}</el-button>
        </div>
        <div class="tableData">
        <el-card>
          <el-table
          :data="Buildings"
          size=mini
          highlight-current-row
          @current-change="selectBuildings"
          :header-cell-style = "{background:'#987AFF'}"
          height='400'>
            <el-table-column type="index" width="40" v-if="!isMobile" />
            <el-table-column property="name" :label="$t('positionInfo.楼栋名称')" :show-overflow-tooltip="true" />
            <el-table-column property="valve" :label="$t('positionInfo.操作')" :width="$i18n.locale === 'en' ? 180 : 150">
              <template slot-scope="scope">
                <el-button size="mini" @click="Buildingmodification(scope.row)">{{$t('positionInfo.修改')}}</el-button>
                <el-button size="mini" @click="Buildingdeletion(scope.row)">{{$t('positionInfo.删除')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        </div>
      </div>
      <!-- 单元 -->
      <div class="modular">
        <div class="query">
          <span>{{$t('positionInfo.单元')}}</span>
          <el-input :placeholder="$t('positionInfo.请搜索')" size="mini" v-model.trim="unistfs.search_content" clearable @clear="QingChu"></el-input>
          <el-button size="mini" @click="unit">{{$t('positionInfo.查询')}}</el-button>
          <el-button size="mini" @click="unitbtn">{{$t('positionInfo.添加')}}</el-button>
        </div>
        <div class="tableData">
        <el-card>
          <el-table
          :data="units"
          size=mini
          highlight-current-row
          @current-change="selectunit"
          :header-cell-style = "{background:'#987AFF'}"
          height='400'>
            <el-table-column type="index" width="40" v-if="!isMobile" />
            <el-table-column property="name" :label="$t('positionInfo.单元名称')" :show-overflow-tooltip="true" />
            <el-table-column property="valve" :label="$t('positionInfo.操作')" :width="$i18n.locale === 'en' ? 180 : 150">
              <template slot-scope="scope">
                <el-button size="mini" @click="Unitmodifbtn(scope.row)">{{$t('positionInfo.修改')}}</el-button>
                <el-button size="mini" @click="Unitmodaleta(scope.row)">{{$t('positionInfo.删除')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        </div>
      </div>
      <!-- 房间 -->
      <div class="modular">
        <div class="query">
          <span>{{$t('positionInfo.房间')}}</span>
          <el-input :placeholder="$t('positionInfo.请搜索')" size="mini" v-model.trim="roomfs.search_content" clearable @clear="QingChu"></el-input>
          <el-button size="mini" @click="room">{{$t('positionInfo.查询')}}</el-button>
          <el-button size="mini" @click="roombtn">{{$t('positionInfo.添加')}}</el-button>
        </div>
        <div class="tableData">
        <el-card>
          <el-table
          :data="rooms"
          size=mini
          highlight-current-row
          :header-cell-style = "{background:'#987AFF'}"
          height='400'>
            <el-table-column type="index" width="40" v-if="!isMobile" />
            <el-table-column property="name" :label="$t('positionInfo.房间名称')" :show-overflow-tooltip="true" />
            <el-table-column property="valve" :label="$t('positionInfo.操作')" :width="$i18n.locale === 'en' ? 180 : 150">
              <template slot-scope="scope">
                <el-button size="mini" @click="roommodify(scope.row)">{{$t('positionInfo.修改')}}</el-button>
                <el-button size="mini" @click="Roomdelete(scope.row)">{{$t('positionInfo.删除')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        </div>
      </div>
    </div>
    <!-- 修改弹框 -->
    <div>
      <!-- 修改小区弹框 -->
  <div class="locationAdd">
  <el-dialog :title="$t('positionInfo.信息修改')" :visible.sync="commfication">
  <el-form :model="modify">
    <el-form-item :label="$t('positionInfo.小区名称') + ' : '" :label-width="formLabelWidth" :required="true">
      <el-input v-model.trim="modify.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Locaficat"><i class="el-icon-document" />{{$t('positionInfo.保存')}}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 修改楼栋弹框 -->
  <div class="locationAdd">
  <el-dialog :title="$t('positionInfo.信息修改')" :visible.sync="Buildingfication">
  <el-form :model="Buildingmodi">
    <el-form-item :label="$t('positionInfo.小区名称') + ':'" :label-width="formLabelWidth" :required="true">
          <el-select v-model="Buildingmodi.community_id" :placeholder="$t('positionInfo.请选择小区')"
          @change="selectmodify(Buildingmodi.community_id)">
            <el-option
                v-for="item in tableData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          </el-form-item>
    <el-form-item :label="$t('positionInfo.楼栋名称') + ': '" :label-width="formLabelWidth" :required="true">
      <el-input v-model.trim="Buildingmodi.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Buildingficat"><i class="el-icon-document" />{{$t('positionInfo.保存')}}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 修改单元弹框 -->
  <div class="locationAdd">
  <el-dialog :title="$t('positionInfo.信息修改')" :visible.sync="Unitfication">
  <el-form :model="Unitcation">
    <el-form-item :label="$t('positionInfo.小区名称') + ':'" :label-width="formLabelWidth" :required="true">
          <el-select v-model="Unitcation.community_id" :placeholder="$t('positionInfo.请选择小区')"
          @change="selectUnit(Unitcation.community_id)">
            <el-option
                v-for="item in tableData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item :label="$t('positionInfo.楼栋名称') + ':'" :label-width="formLabelWidth"  :required="true">
          <el-select v-model="Unitcation.building_id" :placeholder="$t('positionInfo.请选择楼栋')"
          @change="selectBuildingsmodify(Unitcation.building_id)">
            <el-option
                v-for="item in Buildings"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          </el-form-item>
    <el-form-item :label="$t('positionInfo.单元名称') + ' : '" :label-width="formLabelWidth"  :required="true">
      <el-input v-model.trim="Unitcation.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Unitmodificationbtn"><i class="el-icon-document" />{{$t('positionInfo.保存')}}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 修改房间弹框 -->
  <div class="locationAdd">
  <el-dialog :title="$t('positionInfo.信息修改')" :visible.sync="roomfication"  @close="handleClose">
  <el-form :model="Roommodification">
     <el-form-item :label="$t('positionInfo.小区名称') + ':'"  :required="true">
          <el-select v-model="Roommodification.community_id" :placeholder="$t('positionInfo.请选择小区')"
          @change="modifyselectQuarters(Roommodification.community_id)">
            <el-option
                v-for="item in tableData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item :label="$t('positionInfo.楼栋名称') + ':'"  :required="true">
            <el-select v-model="Roommodification.building_id" :placeholder="$t('positionInfo.请选择楼栋')"
            @change="modifyselectBuildings(Roommodification.building_id)">
              <el-option
                v-for="item in Buildings"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('positionInfo.单元名称') + ':'"  :required="true">
            <el-select v-model="Roommodification.unit_id" :placeholder="$t('positionInfo.请选择楼栋')"
            @change="modifyselectunit(Roommodification.unit_id)">
              <el-option
                v-for="item in units"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
    <el-form-item :label="$t('positionInfo.房间名称') + ': '"  :required="true">
      <el-input v-model.trim="Roommodification.name" autocomplete="off" style="width: 230px;"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="roomLocaficat"><i class="el-icon-document" />{{$t('positionInfo.保存')}}</el-button>
  </div>
    </el-dialog>
  </div>
    </div>
    <!-- 添加弹框 -->
    <div>
    <!-- 添加小区弹框 -->
  <div class="locationAdd">
  <el-dialog :title="$t('positionInfo.信息编辑')" :visible.sync="residentialVisible">
  <el-form :model="residentialparameter">
    <el-form-item :label="$t('positionInfo.小区名称') + ' : '" :label-width="formLabelWidth" :required="true">
      <el-input v-model.trim="residentialparameter.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Cellsave"><i class="el-icon-document" />{{$t('positionInfo.保存')}}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 添加楼栋弹框 -->
  <div class="locationAdd">
  <el-dialog :title="$t('positionInfo.信息编辑')" :visible.sync="BuildingVisible">
  <el-form :model="Buildingparameters">
    <el-form-item :label="$t('positionInfo.楼栋名称') + ' : '" :label-width="formLabelWidth" :required="true">
      <el-input v-model.trim="Buildingparameters.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Buildingpreservation"><i class="el-icon-document" />{{$t('positionInfo.保存')}}</el-button>
  </div>
</el-dialog>
  </div>
     <!-- 添加单元弹框 -->
  <div class="locationAdd">
  <el-dialog :title="$t('positionInfo.信息编辑')" :visible.sync="unitVisible">
  <el-form :model="Cellparameters">
    <el-form-item :label="$t('positionInfo.单元名称') + ' : '" :label-width="formLabelWidth" :required="true">
      <el-input v-model.trim="Cellparameters.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Unitsave"><i class="el-icon-document" />{{$t('positionInfo.保存')}}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 添加房间弹框 -->
  <div class="locationAdd">
  <el-dialog :title="$t('positionInfo.信息编辑')" :visible.sync="roomVisible">
  <el-form :model="Roomparameters">
    <el-form-item :label="$t('positionInfo.房间名称') + ' : '" :label-width="formLabelWidth" :required="true">
      <el-input v-model.trim="Roomparameters.name" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="primary" size="small" @click="Roompreservation"><i class="el-icon-document" />{{$t('positionInfo.保存')}}</el-button>
  </div>
</el-dialog>
</div>
    </div>
    </div>
</template>
<script>
export default {
  inject: ['reload'],
  data () {
    return {
      // 添加
      roomVisible: false,
      unitVisible: false,
      BuildingVisible: false,
      residentialVisible: false,
      // 修改
      roomfication: false,
      Unitfication: false,
      commfication: false,
      Buildingfication: false,
      formLabelWidth: '100px',

      tableData: [{
        id: null,
        name: null
      }],
      Buildings: [{
        id: null,
        name: null
      }],
      units: [
        {
          id: null,
          name: null
        }
      ],
      rooms: [],
      // 小区
      comities: {
        token: null,
        search_content: null
      },
      // 修改
      modify: {
        token: null,
        name: null,
        community_id: null
      },
      // 删除
      deleteloca: {
        token: null,
        community_id: null
      },
      // 添加参数
      residentialparameter: {
        token: null,
        name: null
      },
      // 楼栋
      // bulidshow: false,
      munity: null,
      buings: {
        token: null,
        community_id: null,
        search_content: null
      },
      // 修改楼栋
      Buildingmodi: {
        token: null,
        name: null,
        community_id: null,
        building_id: null
      },
      Buildidelet: {
        token: null,
        building_id: null
      },
      // 添加
      Buildingparameters: {
        token: null,
        name: null,
        community_id: null
      },
      // 单元
      // modushow: false,
      unistfs: {
        token: null,
        building_id: null,
        search_content: null
      },
      // 修改
      Unitcation: {
        token: null,
        building_id: null,
        unit_id: null,
        name: null
      },
      // 删除
      Unitcatdelete: {
        token: null,
        unit_id: null
      },
      // 添加
      Cellparameters: {
        token: null,
        name: null,
        building_id: null
      },
      // 房间
      // foomshow: false,
      roomfs: {
        token: null,
        unit_id: null,
        search_content: null
      },
      // 修改
      Roommodification: {
        token: null,
        building_id: null, // ← 必须加上，关闭弹窗时使用
        unit_id: null,
        name: null,
        room_id: null,
        community_id: null // 建议也加上
      },
      oldUnitId: null, // 缓存弹窗打开前的单元id
      Roomdeleteloca: {
        token: null,
        room_id: null
      },
      // 添加
      Roomparameters: {
        token: null,
        name: null,
        unit_id: null
      },
      isMobile: false
    }
  },
  created () {
    this.updateIsMobile()
    this.table()
    this.Buildings = null
    this.units = null
  },
  mounted () {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateIsMobile)
  },
  methods: {
    updateIsMobile () {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    },
    // 输入框清除
    QingChu () {
      console.log('112')
      this.reload()
    },
    // 获取小区
    table () {
      this.comities.token = this.$store.state.print.goodsForeNo.token
      this.$api.userProfile.communities(this.comities).then((res) => {
        if (res.data.status === 'success') {
          console.log(res.data.data, '获取小区')
          this.tableData = res.data.data
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
          this.$router.push('/', this.fasinull)
        }
      })
    },
    handleCurrentChange (val, index) {
      console.log(val, '你是小区吗')
      if (val && val.id) {
        this.munity = val.id
      }
      // this.bulidshow = true
      // this.modushow = false
      // this.foomshow = false
      this.units = null
      this.rooms = null
      this.Building()
    },
    // 修改小区
    Cellbtn (row) {
      console.log(row)
      this.xigai = row.id
      this.modify.name = row.name
      this.commfication = true
    },
    Locaficat () {
      this.modify.token = this.$store.state.print.goodsForeNo.token
      this.modify.community_id = this.xigai
      this.$api.Location.postcommunities(this.modify).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '修改')
          this.table()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
      this.commfication = false
      this.modify.name = null
    },
    // 删除
    Celldeletion (row) {
      this.deleteloca.token = this.$store.state.print.goodsForeNo.token
      this.deleteloca.community_id = row.id
      this.$confirm(('此操作将永久删除该小区, 是否继续?'), ('提示'), {
        confirmButtonText: this.$t('positionInfo.确定'),
        cancelButtonText: this.$t('positionInfo.取消'),
        type: 'warning'
      }).then(() => {
        this.$api.Location.deletecommunities(this.deleteloca).then((res) => {
          if (res.data.status === 'success') {
            console.log(res, '删除')
            this.table()
            this.$notify({
              title: this.$t('message.成功'),
              message: this.$t('positionInfo.删除成功'),
              type: 'success'
            })
          } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('positionInfo.已取消删除')
        })
      })
    },
    // 添加小区
    residentialbtn () {
      this.residentialVisible = true
    },
    Cellsave () {
      this.residentialparameter.token = this.$store.state.print.goodsForeNo.token
      this.$api.Location.putcommunities(this.residentialparameter).then((res) => {
        console.log(res, '添加')
        if (res.data.status === 'success') {
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('positionInfo.添加成功'),
            type: 'success'
          })
          this.table()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
      this.residentialVisible = false
      this.residentialparameter.name = null
    },
    // 获取楼栋
    Building () {
      this.buings.token = this.$store.state.print.goodsForeNo.token
      this.buings.community_id = this.munity
      this.$api.userProfile.buildings(this.buings).then((res) => {
        console.log(res.data.data, '获取楼栋')
        this.Buildings = res.data.data
      })
    },
    selectBuildings (val) {
      console.log(val, 'val2')
      if (val && val.id) {
        this.unis = val.id
      }
      // this.modushow = true
      // this.foomshow = false
      this.rooms = null
      this.unit()
    },
    // 修改楼栋
    Buildingmodification (row) {
      console.log(row)
      this.Buildingmodi.building_id = row.id // 要修改的楼栋ID
      this.Buildingmodi.community_id = row.community_id // 小区id
      this.Buildingmodi.name = row.name
      this.Buildingfication = true
    },
    // 修改
    selectmodify (val) {
      console.log(val, 'val')
      this.modify.community_id = val
      // this.Building()
    },
    Buildingficat () {
      this.Buildingmodi.token = this.$store.state.print.goodsForeNo.token
      // this.modify.building_id = this.ooo
      this.$api.Location.postbuildings(this.Buildingmodi).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '修改')
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('positionInfo.修改成功'),
            type: 'success'
          })
          this.Building()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
      this.Buildingfication = false
      this.Buildingmodi.name = null
    },
    // 楼栋删除
    Buildingdeletion (row) {
      console.log(row, '删除')
      this.Buildidelet.token = this.$store.state.print.goodsForeNo.token
      this.Buildidelet.building_id = row.id
      this.$confirm(('此操作将永久删除该楼栋, 是否继续?'), ('提示'), {
        confirmButtonText: this.$t('positionInfo.确定'),
        cancelButtonText: this.$t('positionInfo.取消'),
        type: 'warning'
      }).then(() => {
        this.$api.Location.deletebuildings(this.Buildidelet).then((res) => {
          if (res.data.status === 'success') {
            console.log(res, '删除')
            this.Building()
            this.$notify({
              title: this.$t('message.成功'),
              message: this.$t('positionInfo.删除成功'),
              type: 'success'
            })
          } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('positionInfo.已取消删除')
        })
      })
    },
    // 添加
    Buildingbtn () {
      this.BuildingVisible = true
    },
    Buildingpreservation () {
      this.Buildingparameters.token = this.$store.state.print.goodsForeNo.token
      this.Buildingparameters.community_id = this.munity
      this.$api.Location.putbuildings(this.Buildingparameters).then((res) => {
        console.log(res, '添加')
        if (res.data.status === 'success') {
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('positionInfo.添加成功'),
            type: 'success'
          })
          this.Building()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
      this.BuildingVisible = false
      this.Buildingparameters.name = null
    },
    // 单元
    unit () {
      this.unistfs.token = this.$store.state.print.goodsForeNo.token
      this.unistfs.building_id = this.unis
      this.$api.userProfile.units(this.unistfs).then((res) => {
        console.log(res.data.data, '获取单元')
        this.units = res.data.data
      })
    },
    selectunit (val) {
      console.log(val, '获取房间')
      if (val && val.id) {
        this.rom = val.id
      }
      // this.foomshow = true
      this.room()
    },
    // 修改
    Unitmodifbtn (row) {
      console.log(row, '单元修改', this.munity)
      this.Unitcation.community_id = this.munity // 小区id
      this.Unitcation.building_id = row.building_id // 楼栋id
      this.Unitcation.unit_id = row.id // 单元id
      this.Unitcation.name = row.name // 单元名称
      this.Unitfication = true
    },
    // 修改单元选择小区
    selectUnit (val) {
      console.log(val)
      this.munity = val
      this.buings.token = this.$store.state.print.goodsForeNo.token
      this.buings.community_id = this.munity
      this.$api.userProfile.buildings(this.buings).then((res) => {
        console.log(res.data.data, '获取楼栋')
        if (res.data.data?.length === 0) {
          // 没有单元，保持清空
          this.Buildings = []
          this.Unitcation.building_id = null
        } else {
          this.Buildings = res.data.data
        }
      })
    },
    // 修改单元选择楼栋
    selectBuildingsmodify (val) {
      console.log(val, 'val')
      this.Unitcation.building_id = val
    },
    // 修改单元的保存按钮
    Unitmodificationbtn () {
      this.Unitcation.token = this.$store.state.print.goodsForeNo.token
      this.$api.Location.postunits(this.Unitcation).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '修改')
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('positionInfo.修改成功'),
            type: 'success'
          })
          this.unit()
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
      })
      this.Unitfication = false
      this.Unitcation.name = null
    },
    // 单元删除
    Unitmodaleta (row) {
      console.log(row, '删除')
      this.Unitcatdelete.token = this.$store.state.print.goodsForeNo.token
      this.Unitcatdelete.unit_id = row.id
      this.$confirm(('此操作将永久删除该单元, 是否继续?'), ('提示'), {
        confirmButtonText: this.$t('positionInfo.确定'),
        cancelButtonText: this.$t('positionInfo.取消'),
        type: 'warning'
      }).then(() => {
        this.$api.Location.deleteunits(this.Unitcatdelete).then((res) => {
          if (res.data.status === 'success') {
            console.log(res, '删除')
            this.$notify({
              title: this.$t('message.成功'),
              message: this.$t('positionInfo.删除成功'),
              type: 'success'
            })
            this.unit()
          } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('positionInfo.已取消删除')
        })
      })
    },
    // 添加
    unitbtn () {
      this.unitVisible = true
    },
    // 添加保存
    Unitsave () {
      this.Cellparameters.token = this.$store.state.print.goodsForeNo.token
      this.Cellparameters.building_id = this.unis
      this.$api.Location.putunits(this.Cellparameters).then((res) => {
        console.log(res, '添加')
        if (res.data.status === 'success') {
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('positionInfo.添加成功'),
            type: 'success'
          })
          this.unit()
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        } else if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
      this.unitVisible = false
      this.Cellparameters.name = null
    },
    // 房间
    room () {
      this.roomfs.token = this.$store.state.print.goodsForeNo.token
      this.roomfs.unit_id = this.rom
      this.$api.userProfile.rooms(this.roomfs).then((res) => {
        console.log(res.data.data, '获取房间')
        this.rooms = res.data.data
      })
    },
    // 修改
    roommodify (row) {
      console.log(row, '房间修改')
      // 弹窗打开时缓存原楼栋id
      this.oldBuildingId = this.unis
      this.oldUnitId = row.unit_id
      this.Roommodification.community_id = this.munity // 小区id
      this.Roommodification.building_id = this.unis // 楼栋id
      this.Roommodification.unit_id = row.unit_id // 单元id
      this.Roommodification.room_id = row.id // 房间id
      this.Roommodification.name = row.name // 房间名称
      this.roomfication = true
    },
    // 修改小区
    modifyselectQuarters (val) {
      console.log(val, 'val')
      this.munity = val
      this.buings.token = this.$store.state.print.goodsForeNo.token
      this.buings.community_id = this.munity
      this.$api.userProfile.buildings(this.buings).then((res) => {
        const buildings = res.data.data || []
        console.log(buildings, '获取楼栋')
        if (buildings.length === 0) {
          // 没有楼栋，清空弹框选择和下拉内容
          this.Roommodification.building_id = null
          this.Buildings = []
        } else {
          // 有楼栋，更新下拉内容
          this.Buildings = buildings
        }
      })
    },
    // 修改楼栋
    modifyselectBuildings (val) {
      console.log(val, '修改房间楼栋')
      this.unis = val
      // 先清空单元下拉框和选中项，保证每次点击都刷新
      this.units = []
      this.Roommodification.unit_id = null
      this.Roommodification.building_id = val
      this.unistfs.token = this.$store.state.print.goodsForeNo.token
      this.unistfs.building_id = val
      this.$api.userProfile.units(this.unistfs).then((res) => {
        console.log(res.data.data, '获取单元')
        if (res.data.data?.length === 0) {
          // 没有单元，保持清空
          this.units = []
          this.Roommodification.unit_id = null
        } else {
          this.units = res.data.data
        }
      })
    },
    // 单元
    modifyselectunit (val) {
      console.log(val, 'val')
      this.Roommodification.unit_id = val
    },
    // 修改保存
    roomLocaficat () {
      // 保存时清空缓存
      this.oldBuildingId = null
      this.Roommodification.token = this.$store.state.print.goodsForeNo.token
      this.$api.Location.postrooms(this.Roommodification).then((res) => {
        if (res.data.status === 'success') {
          console.log(res, '修改')
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('positionInfo.修改成功'),
            type: 'success'
          })
          this.table()
          this.Building()
          this.unit()
          this.room()
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        } else if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
      this.roomfication = false
      this.Roommodification.name = null
    },
    handleClose () {
      // 没有保存直接关闭弹窗时恢复楼栋id
      if (this.oldBuildingId !== null) {
        this.Roommodification.building_id = this.oldBuildingId
        // 重新加载楼栋下拉框数据
        this.unis = this.oldBuildingId
        this.Building() // 刷新楼栋列表
        // 如果需要刷新单元列表
        this.unit()
        this.room() // 关键：刷新房间列表
        this.oldBuildingId = null
      }
      console.log('Dialog closed.', this.Roommodification.building_id)
    },
    // 删除
    Roomdelete (row) {
      console.log(row, '删除')
      this.Roomdeleteloca.token = this.$store.state.print.goodsForeNo.token
      this.Roomdeleteloca.room_id = row.id
      this.$confirm(('此操作将永久删除该房间, 是否继续?'),('提示'), {
        confirmButtonText: this.$t('positionInfo.确定'),
        cancelButtonText: this.$t('positionInfo.取消'),
        type: 'warning'
      }).then(() => {
        this.$api.Location.deleterooms(this.Roomdeleteloca).then((res) => {
          if (res.data.status === 'success') {
            console.log(res, '删除')
            this.$notify({
              title: this.$t('message.成功'),
              message: this.$t('positionInfo.删除成功'),
              type: 'success'
            })
            this.room()
          } else if (res.data.status === 'error') {
            this.$message.error(res.data.message)
          } else if (res.data.message === '用户在别处登录') {
            this.$router.push('/', this.fasinull)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('positionInfo.已取消删除')
        })
      })
    },
    // 添加
    roombtn () {
      this.roomVisible = true
    },
    // 添加保存
    Roompreservation () {
      this.Roomparameters.token = this.$store.state.print.goodsForeNo.token
      this.Roomparameters.unit_id = this.rom
      this.$api.Location.putrooms(this.Roomparameters).then((res) => {
        console.log(res, '添加')
        if (res.data.status === 'success') {
          this.$notify({
            title: this.$t('message.成功'),
            message: this.$t('positionInfo.添加成功'),
            type: 'success'
          })
          this.room()
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        } else if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
      this.roomVisible = false
      this.Roomparameters.name = null
    }
  }
}
</script>
<style lang="less" scoped>
// 面包屑
.Gnv {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;
  //   font-family: myFont;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 20px;
    .yai{
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item{
      margin-left: 0px;
      .el-breadcrumb__inner.is-link{
        font-weight: 100;
        color: #656d92;
  }
    }
  }
}
.lisai{
  margin: 20px auto;
  // width: 90%;
  display: flex;
  flex-wrap: wrap;
  .modular{
    width: 22%;
    height: 500px;
    border: 1px solid slategray;
    border-radius: 10px;
    padding: 20px 10px 0px 10px;
    margin-left: 20px;
    .query{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .el-input{
        width: 200px;
      }
    }
    .tableData{
        margin-top: 20px;
        // 分页
        .el-pagination{
          ::v-deep .el-pagination__rightwrapper{
            float: left;
            margin-left: 20px;
          }
        }
        .el-card{
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table tr{
            background-color: #F9F9F9;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
          background-color: #744dfe;
          color: #FFF;
        }
    }
    }
}
.locationAdd{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 20%;
    }
  }
  }
 // 移动端
 @media (max-width: 768px) {
  .Gnv{
    display: none;
  }
  .lisai{
    margin: 10px auto;
    .modular{
      margin-top: 20px;
      margin-left: 0px;
      width: 92%;
    }
  }
  .locationAdd{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 90%;
    }
    ::v-deep .el-form-item.is-required{
      margin-bottom: 6px;
    }
  }
  }
 }
</style>
